import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getRefundAmount } from '../../../../../selectors/tools';
import DTCopyTextSendMacroView from '../DTCopyTextSendMacroView';
import { shopifyPriceMatchPartialRefund } from '../../../../../actions/tools/ShopifyActions';
import { withConfirmation } from '../../../DTConfirmationView/withConfirmation';

const DTSendConstructedMacroAndPartialRefundItemsNode = () => {
  const dispatch = useDispatch();
  const refundAmount = useSelector(getRefundAmount);

  const handleNextButtonClick = async () => await dispatch(shopifyPriceMatchPartialRefund());

  return (
    <DTCopyTextSendMacroView
      buttonText={'REFUND'}
      onNextButtonClick={handleNextButtonClick}
      hideCopyText={false}
      popupConfirmationText={`You are about to partially refund a total of $${refundAmount} for the items in this order and copy the response to the text box`}
    />
  );
};

export default withConfirmation(DTSendConstructedMacroAndPartialRefundItemsNode);
